import { useState } from "react";

import { SentenceInput } from "./SentenceInput";

/**
 * The foot of the log: where the next capture lands, and — since the tray agent is not the only
 * way text arrives — where you can put one in by hand.
 *
 * It was a dashed label advertising the capture hotkey. Advertising a shortcut is the wrong job
 * for the one element at the bottom of the log you would naturally click when you have a sentence
 * on the clipboard and no game running, so it stopped naming the key and became the control.
 *
 * Closes on Escape, or on blur with nothing in it. Blur with text left in it keeps the text: the
 * usual reason to click away mid-sentence is to go and copy the rest of it.
 */
export function AddSentence({ onSubmit }: { onSubmit: (text: string) => void }) {
  const [open, setOpen] = useState(false);

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex h-8 items-center rounded-[var(--r-3)] border border-dashed border-line-strong px-[13px] text-[14px]/[1] text-ink-4 hover:border-accent hover:text-[color:var(--accent-text)]"
      >
        クリックまたは取り込みで追加
      </button>
    );
  }

  return (
    <SentenceInput
      autoFocus
      onSubmit={onSubmit}
      onEscape={() => setOpen(false)}
      onBlur={(text) => {
        if (!text.trim()) setOpen(false);
      }}
      placeholder="日本語を貼り付けるか入力…"
      className="h-9 w-full max-w-[520px] rounded-[var(--r-3)] border-[1.5px] border-accent bg-panel px-[11px] font-jp text-[17px]/[1] text-ink outline-none placeholder:text-ink-3"
    />
  );
}
